import React, { useRef } from 'react'
import { MobileAppBanner } from '@enuygun/frontend-components'
import { useDeviceType } from 'hooks/useDeviceType'

const Banner = ({ isTablet: isTabletProp }: { isTablet?: boolean }) => {
  const { isTablet: isTabletDevice } = useDeviceType()
  const isTablet = isTabletProp || isTabletDevice
  const bannerContainerRef = useRef<HTMLDivElement>(null)

  // Banner click tracking (MobileAppBanner component'inin içindeki linklere tıklandığında)
  // Not: MobileAppBanner external component olduğu için click tracking'i component içinde yapamıyoruz
  // Ancak view tracking'i yapabiliyoruz

  return (
    <div ref={bannerContainerRef}>
      <MobileAppBanner data-testid="enuygun-homepage-app-banner" isTablet={isTablet} />
    </div>
  )
}

export default Banner
